var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRangeDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0c.184 0 .333.15.333.333V1h3.334V.333C7.667.15 7.816 0 8 0h.667C8.85 0 9 .15 9 .333V1h2c.368 0 .667.315.667.704v9.259c0 .389-.299.704-.667.704H1c-.368 0-.667-.315-.667-.704v-9.26C.333 1.316.632 1 1 1h2V.333C3 .15 3.15 0 3.333 0H4zm6.333 6H1.667v4.333h8.666V6zM3 2.333H1.667v2.334h8.666V2.333H9V3c0 .184-.15.333-.333.333H8A.333.333 0 017.667 3v-.667H4.333V3c0 .184-.149.333-.333.333h-.667A.333.333 0 013 3v-.667z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/range-date.fd96608b.svg";
export { SvgRangeDate as ReactComponent };